import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { Family } from './useFamily';

export function useReassignFamilyAdvisor() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<{ data: Family }, Error, { familyId: string; advisorUserId: string }>({
    mutationFn: ({ familyId, advisorUserId }) =>
      api.post<Family>(`families/${familyId}/reassign-advisor`, { advisorUserId }),
    onSuccess: (_data, { familyId }) => {
      queryClient.invalidateQueries({ queryKey: ['families'] });
      queryClient.invalidateQueries({ queryKey: ['families', familyId] });
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const reassignFamilyAdvisor = async (familyId: string, advisorUserId: string) => {
    return mutateAsync({ familyId, advisorUserId });
  };

  return {
    reassignFamilyAdvisor,
    error,
    isLoading,
    reset,
  };
}
